import { useState } from 'react'
import { useSelector } from 'react-redux'

import GridElementContainer from '../../../GridElementContainer'
import WalletItem from './WalletItem'
import Button from 'components/UI/Button'

import { selectRole } from '../../../../../../../routing/fetchingfunction/user/user.reducer'

import { myWalletCurrencies } from 'constants/dashboard'
import { TUTOR_ROLE } from '../../../../../../../constants'

export const MyWallet = ({ className = '', containerClassName }) => {
  const role = useSelector(selectRole)

  const [currency, setCurrency] = useState(myWalletCurrencies[0].value)

  const isTutor = role === TUTOR_ROLE

  const handleCurrencyChange = (value) => {
    setCurrency(value)
  }

  const myWalletCurrenciesContent = myWalletCurrencies.map((walletCurrency) => {
    return (
      <button
        key={walletCurrency.icon}
        className={`w-[30px] h-[30px] opacity-70 hover:opacity-100 ${currency === walletCurrency.value ? '!opacity-100' : ''}`}
        onClick={() => handleCurrencyChange(walletCurrency.value)}
      >
        <img
          className={`inline-block w-full h-full !border-2 border-transparent rounded-circle ${currency === walletCurrency.value ? '!border-primary-300' : ''}`}
          src={walletCurrency.icon}
          alt={walletCurrency.value}
        />
      </button>
    )
  })

  return (
    <GridElementContainer className={containerClassName} title="My Wallet">
      <div className={`${className} w-full`}>
        <div
          className={`${isTutor ? '!py-[9px]' : 'py-[15.3px]'} !border border-primary-450 rounded bg-primary-500 mb-[6px] flex items-center justify-center gap-[10px]`}
        >
          {myWalletCurrenciesContent}
        </div>
        <div className="grid grid-rows-2 grid-cols-2 gap-[6px]">
          <WalletItem label="Balance" value="€ 125" />
          <WalletItem label="Total" value="€ 125" />
          <WalletItem label="Monthly" value="€ 125" />
          <WalletItem label="Weekly" value="€ 125" />
        </div>
        {isTutor && (
          <Button className="py-[6px] mt-[10px] block w-full" variant="success">
            Withdraw
          </Button>
        )}
      </div>
    </GridElementContainer>
  )
}

export default MyWallet
